(() => {
  const mount = (root) => {
    if (root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const rail = root.querySelector('[data-story-rail]');
    const looks = [...root.querySelectorAll('[data-story-look]')];
    const choices = [...root.querySelectorAll('[data-story-choice]')];
    if (!rail || !looks.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mark = (name) => choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.storyChoice === name)));
    const go = (look) => {
      const delta = look.getBoundingClientRect().left - rail.getBoundingClientRect().left - parseFloat(getComputedStyle(rail).paddingLeft || '0');
      rail.scrollTo({left: rail.scrollLeft + delta, behavior: reduced.matches ? 'instant' : 'smooth'});
      mark(look.dataset.storyLook);
    };
    choices.forEach(button => button.addEventListener('click', () => {
      const look = looks.find(item => item.dataset.storyLook === button.dataset.storyChoice);
      if (look) go(look);
    }));
    let frame = 0;
    rail.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const left = rail.getBoundingClientRect().left + parseFloat(getComputedStyle(rail).paddingLeft || '0');
        const closest = looks.reduce((a,b) => Math.abs(a.getBoundingClientRect().left-left) < Math.abs(b.getBoundingClientRect().left-left) ? a : b);
        mark(closest.dataset.storyLook);
      });
    }, {passive:true});
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const active = Math.max(0, choices.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? looks.length-1 : Math.min(looks.length-1, Math.max(0, active + (event.key === 'ArrowRight' ? 1 : -1)));
      go(looks[index]);
    });
  };
  const init = scope => scope.querySelectorAll('[data-terraza-story]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
